import { IconBriefcase, IconClients, IconClock, IconHome, IconInfo, IconLocation } from 'utils/icons';

// ==============================|| OVĚŘOVACÍ DŮVODY - IKONY ||============================== //
// Sdílený zdroj pravdy pro klíč uložený v attendance_verification_reasons.icon
// (2026-08-29) - admin (VerificationReasonsManager.jsx) i obě zaměstnanecká
// místa, kde appka nabízí checklist důvodů (AttendanceAccordion.jsx,
// Profile/index.jsx), musí rozumět STEJNÉ sadě klíčů, jinak by admin mohl
// vybrat ikonu, kterou appka zaměstnanci nikdy nezobrazí.

export const VERIFICATION_REASON_ICON_OPTIONS = [
  { key: '', label: 'Bez ikony', Icon: null },
  { key: 'home', label: 'Domov', Icon: IconHome },
  { key: 'briefcase', label: 'Zakázka/práce', Icon: IconBriefcase },
  { key: 'location', label: 'Lokace', Icon: IconLocation },
  { key: 'clients', label: 'Klient/pobočka', Icon: IconClients },
  { key: 'clock', label: 'Zpoždění', Icon: IconClock },
  { key: 'info', label: 'Jiné', Icon: IconInfo }
];

export function verificationReasonIconFor(key) {
  return VERIFICATION_REASON_ICON_OPTIONS.find((o) => o.key === key)?.Icon ?? null;
}
